module.exports = __webpack_public_path__ + "img/CCK.6e47dcef.svg";